import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "GoogleModule"
const debug = false

export class SSOMicrosoftModule extends ModuleProto {

    public userMicrosoftAccounts   : any[]
    // public organizationTenantId    : string | null


    constructor() {
        super(ModuleType.SSO_MICROSOFT, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        this.name                       = "Login With Microsoft"
        this.description                = "The Login with Microsoft module enables users to quickly sign in using their Microsoft account, streamlining access and enhancing security."
        this.svgIcon                    = "isvg-microsoft-auth-integration"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                  = "Integrations"
        this.settingsUrl                = "settings/integrations/microsoft"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.canAccess                  = true // backend sends all data for admins and only user account for regular users

        this.userMicrosoftAccounts      = []
        // this.organizationTenantId    = null


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    // disable = async ()=> {
    //     _.map(this.userMicrosoftAccounts, (login: any)=>{
    //         gd.api.MyAccount.unlinkGoogleAccount(login.googleUserId)
    //     })
    // }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
